const defaultRender = (value) => (value ? value : '--');

const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        render: defaultRender,
    },
    {
        title: 'Service Flow',
        dataIndex: 'pipeline_temp_name',
        render: defaultRender,
    },
    {
        title: 'Unsubmitted Files',
        dataIndex: 'unsubmitted_file',
        render: (value) => <p className="sub-title">{value}</p>,
    },
    {
        title: 'In-Process Files',
        dataIndex: 'inprocess_file',
        render: (value) => <p className="sub-title">{value}</p>,
    },
    {
        title: 'Closed Files',
        dataIndex: 'closed_file',
        render: (value) => <p className="sub-title">{value}</p>,
    },
    {
        title: 'Total Files',
        dataIndex: 'total_file',
        render: (value) => <p className="sub-title">{value}</p>,
    },
    {
        title: 'Action',
        dataIndex: 'actions',
        render: defaultRender,
    },
];

export default columns;